import React from 'react';

const List: React.VFC = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0417 6.20833H20.7917V9.125H12.0417V6.20833ZM12.0417 12.0417H20.7917V14.9583H12.0417V12.0417ZM12.0417 17.875H20.7917V20.7917H12.0417V17.875ZM6.20833 6.20833H9.125V9.125H6.20833V6.20833ZM6.20833 12.0417H9.125V14.9583H6.20833V12.0417ZM6.20833 17.875H9.125V20.7917H6.20833V17.875ZM25.3125 0.375H1.6875C0.958333 0.375 0.375 0.958333 0.375 1.6875V25.3125C0.375 25.8958 0.958333 26.625 1.6875 26.625H25.3125C25.8958 26.625 26.625 25.8958 26.625 25.3125V1.6875C26.625 0.958333 25.8958 0.375 25.3125 0.375ZM23.7083 23.7083H3.29167V3.29167H23.7083V23.7083Z" fill="#333333" />
  </svg>
);

export default List;
